<template>
  <div id="app">
    <Head></Head>
    <router-view/>
    <Foot></Foot>
  </div>
</template>

<script>
import Head from '@/components/header'
import Foot from '@/components/footer'
export default {
  name: 'App',
  components: {
    Head,
    Foot
  }
}
</script>

<style lang="less">
/* 重置样式 */
@import url("../static/css/common.css");

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #19191A;
}
/* 分页器 */
@media screen and (min-width: 1029px) and (max-width: 1440px){
  .el-pager li{
    font-size: 16px;
    line-height: 30px!important;
    height: 30px!important;
    width: 30px;
    border-radius: 50%!important;
  }
}
@media screen and (min-width: 1445px){
  .el-pager li{
    font-size: 16px;
    line-height: 40px!important;
    height: 40px!important;
    width: 40px;
    border-radius: 50%!important;
  }
}
.el-pagination{
  display: inline-block;
  text-align: center;
  color: #19191A;
  padding: 0;
}
.el-pagination.is-background .el-pager li{
  background: #fff !important;
  color: #19191A;
}
.el-pagination.is-background .el-pager li:not(.disabled).active{
  background-color: #19191A !important;
}
/* 管理中心页输入框 */
.ManagementCenter .inputBox .el-input__inner{
  border-radius: 8px;
  font-size: 12px;
}
/* 评分 */
.EvaluationWrap .el-rate__icon, .el-rate__item{
  width: 22px;
  height: 22px;
  background: url('./assets/img/evaluate.svg') no-repeat center;
  background-size: 100% 100%;
}
@media screen and (min-width: 1029px){
  .EvaluationWrap .el-rate__item{
    margin-right: 10px;
  }
}
@media screen and (min-width: 320px) and (max-width: 1024px){
	.EvaluationWrap .el-rate__item{
	  margin-right: 3px;
	}
}
.EvaluationWrap .el-rate__icon{
  margin-right: 0;
}
.EvaluationWrap .el-icon-star-on{
  background: url('./assets/img/evaluated.svg') no-repeat center;
  background-size: 100% 100%;
}
.EvaluationWrap .el-icon-star-on:before{
  content:''
}
.EvaluationWrap .el-icon-star-off:before{
  content: '';
}
.EvaluationWrap .el-rate__text{
  position: absolute;
  top: -20px;
  right: 10px;
  color: rgba(25,25,26,0.40)!important;
  font-size: 12px;
}
/* 多行文本框 */
.CurriculumEvaluation .el-textarea__inner,.ContactUs .el-textarea__inner{
  padding: 20px;
  border: 1px solid rgba(25,25,26,0.20);
  border-radius: 8px;
  font-size: 14px;
  resize: initial;
  color: #19191A;
}
/* 视频 */
.prism-player,.prism-player video,.prism-player .prism-cover{
  border-radius: 15px;
}
.prism-player .prism-controlbar .prism-controlbar-bg{
	border-radius: 0 0 16px 16px;
}
/* 下拉框 */
.personalCenter .el-dropdown{
  color: #19191A;
  font-weight: bold;
}
.personalCenter .el-icon-arrow-down:before {
  color: #19191a;
  font-weight: bold;
  font-size: 14px;
}
/* 日历选择器 */
.StudentManagement .el-date-editor .el-range-separator{
  padding: 0;
}
/* 提示框 */
@media screen and (min-width: 320px) and (max-width: 1024px){
	.el-message-box__wrapper .el-message-box{
		width: 80%;
	}
}
.el-message-box__wrapper .el-message-box{
  border-radius: 15px;
  text-align: center;
}
.el-message-box__wrapper .el-message-box__header{
  padding: 30px 15px 0;
}
.el-message-box__wrapper .el-message-box__headerbtn{
  background-color: rgba(25,25,26,0.10);
  border-radius: 50%;
  width: 25px;
  height: 25px;

  top: 25px;
  right: 25px;
}
.el-message-box__wrapper .el-message-box__headerbtn:focus .el-message-box__close, .el-message-box__headerbtn:hover .el-message-box__close {
  color: #fff;
}
.el-message-box__wrapper .el-message-box__headerbtn .el-message-box__close{
  color: #fff;
}
.el-message-box__wrapper .el-message-box__content{
  color: #19191A;
  font-size: 18px;
  font-weight: bold;
  padding: 0;
  margin: 40px 0;
}
.el-message-box__wrapper .el-message-box__btns{
  text-align: center;
}
.el-message-box__wrapper .el-button--primary{
  font-size: 18px;
  color: #0061FE;
  width: 169px;
  margin: 0 auto 10px;
  border: 0;
  background-color: #fff;
}
.el-message-box__wrapper .el-button--primary:active,.el-message-box__wrapper .el-button--primary:focus,.el-message-box__wrapper .el-button--primary:hover {
  background-color: #fff;
  color: #0061FE;
}
</style>



// WEBPACK FOOTER //
// src/App.vue